module.exports = __webpack_public_path__ + "static/media/food-carton-interior.e0dce83c.png";